import React from "react";
import AddUserForm from "./AddUserForm";

const AddUser = () => {
   

    return <AddUserForm  />;
};

export default AddUser;